

export const fieldsInitial = {
  gatepassId: "",
  Date: "",
  docno: "",
  warehouseId: "",
  inTime:"",
  outTime: "",
  farmerType: "",
  farmer_id: "",
  SupervisorEmployeeId: "",
  type: "",
  type_id: "",
  type_text: "",
  personName: "",
  FarmerEmployeeId: "",
  email: "",
  contactnumber: "",
  contactnumberwork: "",
  productDetails: "",
  vehicledrivername: "",
  drivercontactnumber: "",
  loadQuantity: "",
  unitId: "",
  remarkNote: "",
  vehiclenumber: "",
  orgId: "",
  Status: "",
  createdDate: "",
  createdBy: "",
  issused: "",
};

export const farmerTypeOptions = [
  { value: 1, label: "New Farmer" },
  { value: 2, label: "Existing Farmer" },
  { value: 3, label: "Employee" },
  // { value: 4, label: "Other" },
];

export function switchType(option) {
  if (option) {
    switch (option.value) {
      case 1:
        return [{ value: "Procurement", label: "Procurement" }];
      
      case 2:
        return [{ value: "Procurement", label: "Procurement" },        
        { value: "Bring Tobacco Procurement", label: "Bring Tobacco Procurement" },
        { value: "Bring Other Produced", label: "Bring Produced" }];
     case 3:
        return [
          { value: "Purchase Order", label: "Purchase Order" },
          // { value: "Sales", label: "Sales" },
          // { value: "SalesReturn", label: "SalesReturn" },
          // { value: "Maintenance", label: "Maintenance" },
          // { value: "GoodReturn", label: "Good Return" },
          { value: "Harvest", label: "Harvest" },
          { value: "Direct Harvest", label: "Direct Harvest" },
        ];
      case 4:
        return [{ value: "Purchase", label: "Purchase" }];
        
    }
  } else   return [{ value: "Select", label: "Select" }];
}

export function switchEmpFar(option) {
  return option ? option.label   : "";
}

export function switchEmplabelFar(option) {
  if(option&&option.label!="New Farmer")
  {
    return  option.label +" No :"  ;
  }
  else
  {
    return   ""  ;
  }

  return option ? option.label +" No :" : "";
}
